// extracted by mini-css-extract-plugin
export default {"cardsContainer":"styles_cardsContainer__s2525","card":"styles_card__H8MLf"};